import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const FreeSoloDropdown = (props) => {
  const {options, label, onChange, value, placeholder, ...otherProps} = props;

  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      onInputChange={(event, newInputValue) => {
        onChange(newInputValue);
      }}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      renderInput={(params) => <TextField {...params} label={label} variant="outlined" placeholder={placeholder}/>}
      {...otherProps}
    />
  );
};

FreeSoloDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
};

export default FreeSoloDropdown;
